import { render, staticRenderFns } from "./xuexi.vue?vue&type=template&id=c3014824&scoped=true"
import script from "./xuexi.vue?vue&type=script&lang=js"
export * from "./xuexi.vue?vue&type=script&lang=js"
import style0 from "./xuexi.vue?vue&type=style&index=0&id=c3014824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3014824",
  null
  
)

export default component.exports